import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';



import ToolCards from '../../component/reusable/ToolCards';
import AllScheduleEnqTable from '../../component/scheduleComps/AllScheduleEnqTable';
import UserHeader from '../../component/reusable/UserHeader';

import { exportOrderThunk, getAllOrderThunk, setOrderFromDate, setorderPage, setOrderSearch, setOrderStatus, setOrderToDate, setSelectedTab } from '../../redux/orderSlice';

import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import ScheduleTabs from '../../component/scheduleComps/scheduleList/ScheduleTabs';
import ScheduleFilter from '../../component/scheduleComps/scheduleList/ScheduleFilter';
import { exportScheduleThunk, getAllScheduleThunk, setScheduleFromDate, setSchedulePage, setScheduleSearch, setScheduleSelectedTab, setScheduleToDate } from '../../redux/schedulecartslice';


function ScheduleEnq() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('asc')

    const handleChange = (event, newValue) => {
        dispatch(setScheduleSelectedTab(newValue))
        setAllStatus('')
        dispatch(setSchedulePage(1))
        dispatch(setScheduleSearch(''))
        dispatch(setScheduleFromDate(''))
        dispatch(setScheduleToDate(''))
    };

    const { schedule, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab } = useSelector((state) => state.schedule);
    const scheduleData = schedule?.data
    const totalPages = schedule?.totalPages
    const totalItems = schedule?.totalItems
    const itemsPerPage = schedule?.limit

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'APPROVED' : 'DELETED'


    useEffect(() => {
        dispatch(getAllScheduleThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);


    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportScheduleenq = async () => {
        const status = await dispatch(exportScheduleThunk(`?limit=${100000}`))
        if (status?.payload?.success === true) {
            // console.log("status", status?.payload?.data?.data);

            const exportOrderData = status?.payload?.data?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'customer Name': item?.user?.fullName || '-',
                'Customer Email': item?.user?.email || '-',
                'productNumbers': item.products
                    .flatMap((product) =>
                        product.productDetails?.productOverview?.productNumber || []
                    )
                    .join(", "),
                'created by':item?.userType === "USER" ? 'Customer' : 'Self',
                'Total': item?.priceBreakup?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "schedule")
        }
    }





    return (
        <>
            <UserHeader
                index="Schedule Enquiries"
                root="Dashboard"
                onClickadd={() => navigate('/schedule/newSchedule')}
                buttonText={'New Schedule'}
                exportData={exportScheduleenq}
                exportLoading={exportLoading}
            />
            <ToolCards />
            <Box>
                <ScheduleTabs handleChange={handleChange} selectedTab={selectedTab} />
                <ScheduleFilter setAllStatus={setAllStatus} search={search} selectedTab={selectedTab} />
                
                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {scheduleData?.length > 0 ?
                                    <Typography>
                                        <AllScheduleEnqTable
                                            scheduleData={scheduleData}
                                            page={page}
                                            setPage={setSchedulePage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>
            </Box>
        </>
    );
}

export default ScheduleEnq;
